// Brand-specific signup / dashboard login URL.
// Resolved at build time from REACT_APP_BRAND — throws on unknown brands.

const BRAND = process.env.REACT_APP_BRAND;

let BASE_URL;
switch (BRAND) {
  case "ringfoods":
    BASE_URL = "https://app.ringfoods.com/dashboard/login";
    break;
  case "ringoperator":
    BASE_URL = "https://app.ringoperator.com/dashboard/login";
    break;
  default:
    throw new Error(
      `Unknown or missing REACT_APP_BRAND: '${BRAND}'. Must be 'ringfoods' or 'ringoperator'.`
    );
}

export default function useSignupUrl() {
  // Read ref from current URL only — never from localStorage.
  // This prevents stale referral codes from being applied on shared/public computers.
  const urlRef = new URLSearchParams(window.location.search).get("ref");
  if (urlRef) {
    return `${BASE_URL}?ref=${encodeURIComponent(urlRef)}`;
  }
  return BASE_URL;
}
